/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../Fixes';
import Builder from '../../Builder';
import '../common/time';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "paymentreporter": {
        "nested": {
          "service": {
            "nested": {
              "TransactionStatusReportEntry": {
                "fields": {
                  "paymentToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "required"
                  },
                  "status": {
                    "type": ".squareup.paymentreporter.service.TransactionStatusReportEntry.PaymentStatus",
                    "id": 2,
                    "rule": "optional"
                  },
                  "merchantId": {
                    "type": "string",
                    "id": 3,
                    "rule": "required"
                  },
                  "locationId": {
                    "type": "string",
                    "id": 4,
                    "rule": "required"
                  },
                  "orderSource": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  },
                  "paymentCreatedAt": {
                    "type": ".squareup.common.time.DateTime",
                    "id": 6,
                    "rule": "required"
                  }
                },
                "nested": {
                  "PaymentStatus": {
                    "values": {
                      "PENDING": 0,
                      "APPROVED": 1,
                      "COMPLETED": 2,
                      "CANCELED": 3,
                      "FAILED": 4
                    }
                  }
                }
              },
              "TransactionStatusReportRequest": {
                "fields": {
                  "merchantId": {
                    "type": "string",
                    "id": 1,
                    "rule": "required"
                  },
                  "locationIds": {
                    "type": "string",
                    "id": 2,
                    "rule": "repeated"
                  },
                  "beginTime": {
                    "type": ".squareup.common.time.DateTime",
                    "id": 3,
                    "rule": "required"
                  },
                  "endTime": {
                    "type": ".squareup.common.time.DateTime",
                    "id": 4,
                    "rule": "required"
                  },
                  "filters": {
                    "type": ".squareup.paymentreporter.service.TsrFilterByValue",
                    "id": 5,
                    "rule": "repeated"
                  },
                  "includePaymentStatus": {
                    "type": ".squareup.paymentreporter.service.TransactionStatusReportEntry.PaymentStatus",
                    "id": 6,
                    "rule": "repeated"
                  }
                }
              },
              "TsrFilterByValue": {
                "fields": {
                  "devices": {
                    "type": ".squareup.paymentreporter.service.DeviceList",
                    "id": 1
                  },
                  "orderSources": {
                    "type": ".squareup.paymentreporter.service.OrderSourceList",
                    "id": 2
                  }
                },
                "nested": {
                  "filter_value": {
                    "oneof": ["devices", "orderSources"]
                  }
                }
              },
              "NameOrTranslationType": {
                "fields": {
                  "name": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "translationType": {
                    "type": ".squareup.paymentreporter.service.TranslationType",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "DeviceList": {
                "fields": {
                  "devices": {
                    "type": ".squareup.paymentreporter.service.TsrDevice",
                    "id": 1,
                    "rule": "repeated"
                  }
                }
              },
              "TsrDevice": {
                "fields": {
                  "nameOrTranslationType": {
                    "type": ".squareup.paymentreporter.service.NameOrTranslationType",
                    "id": 1,
                    "rule": "optional"
                  },
                  "token": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "OrderSourceList": {
                "fields": {
                  "orderSources": {
                    "type": ".squareup.paymentreporter.service.OrderSource",
                    "id": 1,
                    "rule": "repeated"
                  }
                }
              },
              "OrderSource": {
                "fields": {
                  "nameOrTranslationType": {
                    "type": ".squareup.paymentreporter.service.NameOrTranslationType",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "TranslationType": {
                "values": {
                  "CUSTOM_AMOUNT_ITEM": 0,
                  "UNITEMIZED_TAX": 1,
                  "DEFAULT_DISCOUNT": 2,
                  "DEFAULT_ITEM": 3,
                  "DEFAULT_SALES_TAX": 4,
                  "DEFAULT_TIP": 5,
                  "CHANGE": 6,
                  "REFUND": 7,
                  "CASH_REFUND": 8,
                  "INCLUSIVE_TAX": 9,
                  "DEFAULT_ITEM_MODIFIER": 10,
                  "CREDIT": 11,
                  "SWEDISH_ROUNDING": 12,
                  "SURCHARGE": 13,
                  "DEFAULT_DEVICE": 14,
                  "NO_CATEGORY": 15,
                  "NO_DISCOUNT": 16,
                  "NO_MODIFIER": 17,
                  "NO_SUBUNIT": 18,
                  "NO_MOBILE_STAFF": 19,
                  "NO_EMPLOYEE": 20,
                  "NAMELESS_EMPLOYEE": 78,
                  "CUSTOM_AMOUNT_ITEM_VARIATION": 21,
                  "DEFAULT_ITEM_VARIATION": 22,
                  "NO_MODIFIER_SET": 23,
                  "DEFAULT_MODIFIER_SET": 24,
                  "NO_TAX": 25,
                  "NO_DINING_OPTION": 26,
                  "NO_GIFT_CARD": 27,
                  "NO_VOID_REASON": 28,
                  "NO_COMP_REASON": 29,
                  "DEFAULT_COMP_REASON": 30,
                  "NO_COMP": 31,
                  "TICKET_NAME": 32,
                  "TICKET_GROUP_NAME": 33,
                  "NO_TICKET_GROUP": 34,
                  "NO_DEVICE_CREDENTIAL": 35,
                  "DEFAULT_DEVICE_CREDENTIAL": 36,
                  "NO_EMPLOYEE_ROLE": 37,
                  "EMPLOYEE_ROLE_ACCOUNT_OWNER_ROLE": 38,
                  "EMPLOYEE_ROLE_OWNER_ROLE": 39,
                  "EMPLOYEE_ROLE_DELETED_ROLE": 40,
                  "EMPLOYEE_ROLE_MOBILE_STAFF_ROLE": 41,
                  "NO_CONVERSATIONAL_MODE": 42,
                  "NO_MENU": 43,
                  "NO_TICKET_TEMPLATE": 44,
                  "NO_TICKET_TEMPLATE_CUSTOM_CHECK": 45,
                  "NO_PAYMENT_SOURCE_NAME": 46,
                  "UNKNOWN_PAYMENT_SOURCE_NAME": 47,
                  "NO_CONTACT_TOKEN": 48,
                  "NO_REPORTING_GROUP": 49,
                  "NO_SURCHARGE": 50,
                  "SURCHARGE_AUTO_GRATUITY": 51,
                  "DEFAULT_SURCHARGE_NAME": 52,
                  "DEFAULT_ORDER_SOURCE_NAME": 53,
                  "ORDER_SOURCE_REGISTER": 54,
                  "ORDER_SOURCE_MARKET": 55,
                  "ORDER_SOURCE_ORDER": 56,
                  "ORDER_SOURCE_EXTERNAL_API": 57,
                  "ORDER_SOURCE_APPOINTMENTS": 58,
                  "ORDER_SOURCE_INVOICES": 59,
                  "ORDER_SOURCE_BILLING": 60,
                  "ORDER_SOURCE_STORE": 61,
                  "ORDER_SOURCE_ONLINE_STORE": 62,
                  "ORDER_SOURCE_STARBUCKS": 63,
                  "ORDER_SOURCE_WHITE_LABEL": 64,
                  "ORDER_SOURCE_PAYROLL": 65,
                  "ORDER_SOURCE_CAPITAL": 66,
                  "ORDER_SOURCE_TERMINAL": 67,
                  "ORDER_SOURCE_EGIFTING": 68,
                  "ORDER_SOURCE_CASH": 69,
                  "ORDER_SOURCE_REGISTER_HARDWARE": 70,
                  "ORDER_SOURCE_SUBSCRIPTIONS": 74,
                  "ORDER_SOURCE_FNB_KIOSK": 75,
                  "DEFAULT_MEASUREMENT_UNIT": 71,
                  "NO_VENDOR": 72,
                  "UNKNOWN_VENDOR": 73,
                  "DEFAULT_COMBO": 76,
                  "NO_CHANNEL_ATTRIBUTION": 77,
                  "UNKNOWN_CHANNEL_ATTRIBUTION": 79
                }
              },
              "TransactionStatusReportResponse": {
                "fields": {
                  "reportEntry": {
                    "type": ".squareup.paymentreporter.service.TransactionStatusReportEntry",
                    "id": 1,
                    "rule": "repeated"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.paymentreporter?.nested?.service?.nested?.TransactionStatusReportEntry && !$root.nested?.squareup?.nested?.paymentreporter?.nested?.service?.nested?.TransactionStatusReportEntry?.nested?.PaymentStatus && !$root.nested?.squareup?.nested?.paymentreporter?.nested?.service?.nested?.TransactionStatusReportRequest && !$root.nested?.squareup?.nested?.paymentreporter?.nested?.service?.nested?.TsrFilterByValue && !$root.nested?.squareup?.nested?.paymentreporter?.nested?.service?.nested?.NameOrTranslationType && !$root.nested?.squareup?.nested?.paymentreporter?.nested?.service?.nested?.DeviceList && !$root.nested?.squareup?.nested?.paymentreporter?.nested?.service?.nested?.TsrDevice && !$root.nested?.squareup?.nested?.paymentreporter?.nested?.service?.nested?.OrderSourceList && !$root.nested?.squareup?.nested?.paymentreporter?.nested?.service?.nested?.OrderSource && !$root.nested?.squareup?.nested?.paymentreporter?.nested?.service?.nested?.TranslationType && !$root.nested?.squareup?.nested?.paymentreporter?.nested?.service?.nested?.TransactionStatusReportResponse) {
  $root.addJSON(jsonData);
}

/**
 * Forked from UnsuccessfulPayments.
 *
 * SOURCE TransactionStatusReportEntry @ squareup/paymentreporter/transaction_status_report.proto at 14:1
 */
export const TransactionStatusReportEntry = $root.lookupType('squareup.paymentreporter.service.TransactionStatusReportEntry');
fixType(TransactionStatusReportEntry);
Builder.createAndAttachToType(TransactionStatusReportEntry);
/**
 * SOURCE PaymentStatus @ squareup/paymentreporter/transaction_status_report.proto at 17:3
 */
TransactionStatusReportEntry.PaymentStatus = $root.lookupEnum('squareup.paymentreporter.service.TransactionStatusReportEntry.PaymentStatus').values;
/**
 * SOURCE TransactionStatusReportRequest @ squareup/paymentreporter/transaction_status_report.proto at 44:1
 */
export const TransactionStatusReportRequest = $root.lookupType('squareup.paymentreporter.service.TransactionStatusReportRequest');
fixType(TransactionStatusReportRequest);
Builder.createAndAttachToType(TransactionStatusReportRequest);
/**
 * SOURCE TsrFilterByValue @ squareup/paymentreporter/transaction_status_report.proto at 60:1
 */
export const TsrFilterByValue = $root.lookupType('squareup.paymentreporter.service.TsrFilterByValue');
fixType(TsrFilterByValue);
Builder.createAndAttachToType(TsrFilterByValue);
/**
 * SOURCE NameOrTranslationType @ squareup/paymentreporter/transaction_status_report.proto at 67:1
 */
export const NameOrTranslationType = $root.lookupType('squareup.paymentreporter.service.NameOrTranslationType');
fixType(NameOrTranslationType);
Builder.createAndAttachToType(NameOrTranslationType);
/**
 * SOURCE DeviceList @ squareup/paymentreporter/transaction_status_report.proto at 73:1
 */
export const DeviceList = $root.lookupType('squareup.paymentreporter.service.DeviceList');
fixType(DeviceList);
Builder.createAndAttachToType(DeviceList);
/**
 * SOURCE TsrDevice @ squareup/paymentreporter/transaction_status_report.proto at 77:1
 */
export const TsrDevice = $root.lookupType('squareup.paymentreporter.service.TsrDevice');
fixType(TsrDevice);
Builder.createAndAttachToType(TsrDevice);
/**
 * SOURCE OrderSourceList @ squareup/paymentreporter/transaction_status_report.proto at 82:1
 */
export const OrderSourceList = $root.lookupType('squareup.paymentreporter.service.OrderSourceList');
fixType(OrderSourceList);
Builder.createAndAttachToType(OrderSourceList);
/**
 * SOURCE OrderSource @ squareup/paymentreporter/transaction_status_report.proto at 86:1
 */
export const OrderSource = $root.lookupType('squareup.paymentreporter.service.OrderSource');
fixType(OrderSource);
Builder.createAndAttachToType(OrderSource);
/**
 * SOURCE TranslationType @ squareup/paymentreporter/transaction_status_report.proto at 90:1
 */
export const TranslationType = $root.lookupEnum('squareup.paymentreporter.service.TranslationType').values;
/**
 * SOURCE TransactionStatusReportResponse @ squareup/paymentreporter/transaction_status_report.proto at 211:1
 */
export const TransactionStatusReportResponse = $root.lookupType('squareup.paymentreporter.service.TransactionStatusReportResponse');
fixType(TransactionStatusReportResponse);
Builder.createAndAttachToType(TransactionStatusReportResponse);